import httpClient from './httpClient';

const stock_info = (bc) => httpClient.get('/api/stock_info/'+bc);

export {
    stock_info
}